import { translateKey } from 'src/locales/translate';
// Pet fact type translations (English to Polish)
export const PET_FACT_TYPE_TRANSLATIONS: Record<string, string> = {
  medical: 'Zdrowie',
  lifestyle: 'Lifestyle',
  behavioral: 'Zachowanie',
};

// Pet fact category translations (English to Polish)
export const PET_FACT_CATEGORY_TRANSLATIONS: Record<string, string> = {
  health: 'Zdrowie',
  nutrition: translateKey("hardcoded.zywienie"),
  behavior: 'Zachowanie',
  general: translateKey("hardcoded.ogolne"),
  fun: 'Zabawa',
};

// Pet category translations (English to Polish)
export const PET_CATEGORY_TRANSLATIONS: Record<string, string> = {
  dog: translateKey("visit.petCategoryDog"),
  cat: translateKey("visit.petCategoryCat"),
  rabbit: translateKey("hardcoded.krolik"),
  hamster: 'Chomik',
  bird: 'Ptak',
  fish: 'Ryba',
  reptile: 'Gad',
  other: translateKey("search.specializationOther"),
};
